import BaseModelDocument from "@/models/BaseModelDocument.js";
import BaseModelDocumentManagerToolBar from "@/models/BaseModelDocumentManagerToolBar.js";

export const DocumentManagerGridConfig = {
	list: BaseModelDocument.list,
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			editable: false
		},
		Actions: {
			class: 'value',
			editable: false,
			title: 'Actions',
			width: 150,
			type: 'dropdownactions',
			key: "Id",
			menu: [{
				"Edit": "Edit",
				"Cancel": "Cancel",
				"Delete": "Delete",
				"Save": "Save",
				//"OpenLive": "Open Live",
				"Download": "Download"
			}],
			hidden: false,
			readOnly: true
		},
		FileName: {
			class: 'lookup',
			dataName: 'File/Name',
			type: 'string',
			title: 'File Name',
			width: 200,
			hidden: false
		},
		FileServerRelativeUrl: {
			class: 'lookup',
			dataName: 'File/ServerRelativeUrl',
			type: 'string',
			title: 'ServerRelativeUrl',
			width: 150,
			hidden: true,
			readOnly: true,
			editable: false
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'Program/Id',
			type: 'number',
			title: 'Program ID',
			width: 100,
			hidden: true,
			readOnly: true,
			editable: false
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'string',
			//dropdown: true,
			//source:'ProgramTypeOptions',
			title: 'Program',
			width: 120,
			hidden: false,
			readOnly: true,
			editable: false
		},
		PartnerId: {
			class: 'lookup',
			dataName: 'Partner/Id',
			type: 'number',
			title: 'Partner ID',
			width: 100,
			hidden: true,
			readOnly: true,
			editable: false
		},
		PartnerTitle: {
			class: 'lookup',
			dataName: 'Partner/FullName',
			type: 'string',
			//dropdown: true,
			source: 'PartnerTypeOptions',
			title: 'Partner',
			width: 100,
			hidden: false,
			readOnly: true,
			editable: false
		},
		DocumentType: {
			class: 'choice',
			dataName: 'DocumentType',
			type: 'dropdown',
			title: 'Document Type',
			dropdown: true,
			width: 150,
			hidden: false,
			readOnly: false
		},
		BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'DocumentLevel',
			width: 150,
			hidden: false,
			editable: false,
			readOnly: true
		},
		TransactionID: {
			class: 'value',
			dataName: 'TransactionID',
			type: 'number',
			title: 'Transaction ID',
			width: 100,
			hidden: true,
			editable: false,
			readOnly: true
		},
		BatchGUID: {
			class: 'value',
			dataName: 'BatchGUID',
			type: 'number',
			title: 'Batch Id',
			width: 100,
			hidden: true,
			editable: false,
			readOnly: false
		}
	},
	query: {
		filter: "",
		limit: 5000
	},
	grid: {
		gridId: 'DocumentManagerGrid',
		height: 500,
		checkbox: true
	}
}

const toolbarItems = BaseModelDocumentManagerToolBar.items;

export const DocumentManagerGridToolBarConfig = {
	items: [{
		id: "btnUploadNewDocuments",
		type: "button",
		text: "Upload New Documents",
		icon: "upload",
		showIcon: "toolbar",
		attributes: {
			"class": " btn btn-primary float-right-btn"
		}
	}, ...toolbarItems]
}